import flowRight from "lodash/fp/flowRight";

const capitalizeValues = (searchList) => {
  const keys = new Set(["METHOD", "LEVEL"]);
  return searchList.map((item) =>
    keys.has(item.leftOperand) ? Object.assign(item, { rightOperand: item.rightOperand.toUpperCase() }) : item
  );
};
const ignoreLastConjunction = (searchList) => [
  ...searchList.slice(0, -1),
  Object.assign(searchList.at(-1), { next: null }),
];

const mapOperator = (operator) => {
  const operatorMap = {
    "==": 'LOPERAND == "ROPERAND"',
    ">=": 'LOPERAND >= "ROPERAND"',
    "<=": 'LOPERAND <= "ROPERAND"',
    "!=": 'LOPERAND != "ROPERAND"',
    contains: 'LOPERAND.str.contains("ROPERAND")',
  };
  return operatorMap[operator];
};

const fillOperands = (lOperand, rOperand, _template) => {
  return _template.replace("LOPERAND", lOperand).replace("ROPERAND", rOperand);
};

const concatNext = (_template, next) => {
  return next ? `${_template} ${next.toLowerCase()}` : _template;
};

const createSearchQuery = (searchList) => {
  const preprocessSearchList = flowRight([capitalizeValues, ignoreLastConjunction]);
  return preprocessSearchList(searchList)
    .map((item) => concatNext(fillOperands(item.leftOperand, item.rightOperand, mapOperator(item.operator)), item.next))
    .join(" ");
};

export { createSearchQuery, concatNext, fillOperands, mapOperator };
